// Autosuggest markup
const autosuggestItemHTML = (itemHTML, option, index, searchText) => {
    const text = option._source.post_title;
    const url = option._source.permalink;
    const postDate = new Date(option._source.post_date).toLocaleString('en', { dateStyle: 'medium' })
    const label = option?._source?.meta?.label?.[0]?.raw ?? '';
    const parentGroup = option?._source?.meta?.parent_group?.[0]?.raw ?? '';

    return `<li class="autosuggest-item" role="option" aria-selected="false" id="autosuggest-option-${index}">
		<a href="${url}" class="autosuggest-item__link flex flex-space-between flex-align-center gap-2" data-url="${url}" tabindex="-1">
			${text ? `<span class="autosuggest-item__title">${text}</span>` : ''}
			${label ? `<span class="autosuggest-item__label">${label} ${parentGroup ? `<span style="opacity: 0.5">| ${parentGroup}</span>` : ''}</span>` : ''}
		</a>
	</li>`;
};
wp.hooks.addFilter('ep.Autosuggest.itemHTML', 'myTheme/autosuggestItemHTML', autosuggestItemHTML);

// Autosuggest click events
document.addEventListener('pointerdown', (e) => {
    const link = e.target.closest('.autosuggest-item__link');
    if (!link) return;

    // Right-click: let the context menu work normally
    if (e.button === 2) return;

    // Middle-click (button 1): open in new tab
    if (e.button === 1) {
        e.preventDefault();
        window.open(link.href, '_blank', 'noopener');
        return;
    }

    // Primary click with modifiers:
    if (e.metaKey || e.ctrlKey) { // cmd-click (Mac) or ctrl-click (Win/Linux)
        e.preventDefault();
        window.open(link.href, '_blank', 'noopener');
        return;
    }
    if (e.shiftKey) { // usually "open in new window"
        e.preventDefault();
        window.open(link.href, '_blank');
        return;
    }
    if (e.altKey) {
        // Choose your preferred behavior; here we just fall back to normal nav
    }

    // Plain primary click: navigate in the same tab
    e.preventDefault();
    window.location.assign(link.href);
});



// Instant search results markup
(function () {
    const el = wp.element.createElement;

    const CustomResult = (props) => {
        const url = props.url || '#';
        const type = props.post_type_label || props.type || props.post_type || '';
        const label = props?.hit._source?.meta?.label?.[0]?.raw || '';
        const parentGroup = props?.hit._source?.meta?.parent_group?.[0]?.raw || '';
        // console.log(props)

        return el(
            'a',
            { href: url, className: 'search-result' },
            el(
                'div',
                { className: 'search-result__head' },
                type && el('div', { className: 'search-result__type search-result__tag' }, type),
                label && el('div', { className: 'search-result__label search-result__tag' }, label),
                parentGroup && el('div', { className: 'search-result__parent search-result__tag' }, parentGroup)
            ),
            el(
                'div',
                { className: 'search-result__content' },
                el('h3', {
                    className: 'heading-5 margin-0',
                    dangerouslySetInnerHTML: { __html: props.title || '' }
                })
            )
        );
    };

    wp.hooks.addFilter(
        'ep.InstantResults.Result',
        'myTheme/customResult',
        () => CustomResult
    );
})();
